import React, { useState, useEffect } from 'react'
import { proc_prev_billCols, prev_validColumn } from '../../../constants/procBillConstants'
import { projRmkCol, billCols } from '../../../constants/billConstants'
import { FGLOBAL } from '../../../constants/frontGlobal'
import { EditableProTable } from '@ant-design/pro-table';
import { Tooltip, Button, Modal, Input, Select, Form } from 'antd';
import './bill-mgt.less'

import { getDataResourceWithValid, getRecordWithValid } from './billHelper'
import { upSertAxios, mask, unmask, queryAxios } from '../../../components/reqAndHint'
import { RollbackOutlined, UndoOutlined, SearchOutlined } from '@ant-design/icons';
import { useSelector, useDispatch } from 'react-redux'
import axios from '../../../utils/AxiosUtil';
import { projectChange } from '../../../reducers/projectReducers';
// import { getDeleteCheckedRows } from '../../../components/table/batchDelFunc'

const { Search } = Input;
const { Option } = Select

/**
 * 待处理列表审核明细弹窗
 */
export default function review(props) {
    const volunList = useSelector(state => state.volunList.value)
    // console.log('**vollist;', volunList);
    let [rform] = Form.useForm();
    const langValue = useSelector(state => state.langList.value)
    const projectList = useSelector(state => state.projectList.value)
    const dispatch = useDispatch()
    const [editableKeys, setEditableRowKeys] = useState([]);//正在编辑状态的行
    const [dataSource, setDataSource] = useState([]);
    const [selectedRowKeysArr, setSelectedRowkeysArr] = useState([]);
    const [areas, setAreas] = useState(null);
    const [choosenArea, SetChoosenArea] = useState('');
    const columns = [...billCols];
    const [showSearchBar, setShowSearchBar] = useState(false);
    const [rawData, setRawData] = useState();

    const [amount, setAmount] = useState(0);//总金额

    const [projectArr, setProjectArr] = useState([]); // 用途的选择框

    if (FGLOBAL.get('roleId') && +FGLOBAL.get('roleId') < 4) {
        //地区财务窗口以外人员 表头额外字段
        columns.push(projRmkCol);
    }

    const handleSearch = (value) => {

        //有rawDate则说明是多次搜索
        if (rawData) {
            //有搜索关键词且当前数据和原数据相同，正常过滤
            if (rawData == dataSource && value) {
                // console.log('多次search');
                setRawData(dataSource);
                mask();
                let newData = dataSource.filter(d => d['开立票据名称'].includes(value));
                // console.log('after filter:', newData);
                setDataSource(newData);
                unmask();
                //无关键词，且过滤后和原数据不同，返回原数据
            } else {
                // console.log('多次取消search');
                setDataSource(rawData);
            }

            //没有rowData,说明是第一次搜索
        } else {
            //有关键词，则正常过滤筛选
            if (value) {
                // console.log('第一次search');
                setRawData(dataSource);
                mask();
                let newData = dataSource.filter(d => d['开立票据名称'].includes(value));
                // console.log('after filter:', newData);
                setDataSource(newData);
                unmask();
                //没有值，无反应
            } else {
                // console.log('第一次取消search');
            }
        }

    }
    let showSearchstr
    if (langValue == 0) {
        showSearchstr = showSearchBar ? '点击收起搜索Click to collapse search' : '点击展开搜索Click to expand search'
    }
    else if (langValue == 1) {
        showSearchstr = showSearchBar ? '点击收起搜索' : '点击展开搜索'
    } else {
        showSearchstr = showSearchBar ? 'Click to collapse search' : 'Click to expand search'
    }
    columns[1].title =
        (<div id='procq-scth'>
            <span>{langValue == 0 ? '开立票据名称Receipt Title' : (langValue == 1 ? '开立票据名称' : 'Receipt Title')}</span>

            <span>
                <Tooltip title={showSearchstr}>
                    <SearchOutlined
                        onClick={() => {
                            // console.log('search:', showSearchBar);
                            if (showSearchBar) {
                                //有rawDate则说明是多次筛选
                                if (rawData) {
                                    //rawData和当前数据相同,直接关闭
                                    if (rawData == dataSource) {
                                        // console.log('close search');
                                        //重新生成序号
                                        dataSource.forEach((d, i) => {
                                            d['序号'] = i + 1;
                                        })
                                        setDataSource(dataSource);
                                        setRawData(undefined);

                                        //rawData和当前数据不同,返回原数据
                                    } else {
                                        // console.log('reset and close search');
                                        // console.log('rawdata:', rawData?.length);
                                        // console.log('data:', dataSource?.length);
                                        //重新生成序号
                                        rawData.forEach((d, i) => {
                                            d['序号'] = i + 1;
                                        })
                                        setDataSource(rawData);
                                        setRawData(undefined);
                                    }

                                    //没有rawData,说明是第一次筛选,直接关闭
                                } else {
                                    // console.log('no raw,close search');
                                    //重新生成序号
                                    dataSource.forEach((d, i) => {
                                        d['序号'] = i + 1;
                                    })
                                    setDataSource(dataSource);
                                }

                            } else {
                                // console.log('open search');
                            }

                            setShowSearchBar(!showSearchBar)
                        }}
                        style={{ fontSize: '20px', fontWeight: '1000', border: '1px solid blue', color: 'blue', position: 'relative', left: '5px', top: '2px' }} />
                </Tooltip >
            </span>
            <Search
                placeholder={langValue == 0 ? '输入关键字Enter Keyword' : (langValue == 1 ? '输入关键字' : 'Enter Keyword')}
                allowClear
                enterButton
                onSearch={handleSearch}
                style={{ display: showSearchBar ? 'block' : 'none' }}
            />
        </div>);
    columns[1].width = '10rem';


    useEffect(() => {

        getUserProject();

        (async function () {
            SetChoosenArea(props.recordArea);
            try {
                let data = await queryAxios('/area/area-by-uid', { uid: sessionStorage.getItem('uid') });
                let areas = data ?.data ?.userArea ?.map(area => {
                    return { areaId: area.aid, areaName: area.key }
                });

                if (!areas || !areas.length) {
                    Modal.error({
                        title: langValue == 0 ? '待处理Pending processing' : (langValue == 1 ? '待处理' : 'Pending processing'),
                        content: langValue == 0 ? <>当前用户未关联地区，请联系财务同仁修改<br />The current user is not associated with a region. Please contact the finance team to make changes</> : (langValue == 1 ? '当前用户未关联地区，请联系财务同仁修改' : 'The current user is not associated with a region. Please contact the finance team to make changes')
                    });
                    return null;
                } else {
                    setAreas(areas);
                }

                data = await queryAxios('/billmgt/getBillRecordSubById', { recordId: props.recordId });
                let dtSrc = [...data.data.data.bill_detail];
                dtSrc.forEach((d, i) => { d['序号'] = i + 1; });
                setDataSource(getDataResourceWithValid(dtSrc));

            } catch (e) {
                Modal.error({ title: '待处理：', content: "获取用户信息时出错：" + e });
            }

        })()

    }, [])


    //表格数据变化时，更新总金额
    useEffect(() => {
        let totalAmount = 0;
        dataSource.forEach((d, i) => {
            let amt = Number(d['金额']);
            totalAmount = Number(amt.toFixed(2)) + Number(totalAmount.toFixed(2));
            totalAmount = Number(totalAmount.toFixed(2));
        })
        setAmount(totalAmount);
    }, [dataSource])


    // 根据用户权限获取用途
    const getUserProject = async () => {
        // console.log('procReview getUserProject')
        if (projectList.length < 1) {
            let data = await axios.post('/fund/project/getUserProject', { role_id: FGLOBAL.get('roleId') });
            let projectArr = []
            data.data.forEach(item => {
                var obj = {
                    ch_pro: item,
                    en_pro: item
                }
                projectArr.push(obj)

            })
            dispatch(projectChange({ value: projectArr }))
            setProjectArr(projectArr);
        } else {
            setProjectArr(projectList)
        }
        // alert(1)
        console.log('projectArr:', projectArr)
    }

    const getColumns = (col) => {

        // let projectValueEnum = {}
        // projectArr ?.forEach(p => {
        //     let value = { text: p }
        //     projectValueEnum[p] = value;
        // });

        // // 设置用途字段的下拉选项 
        // col[5].valueEnum = projectValueEnum;

        let operCol = {
            title: '操作',
            en_title: 'Operation',
            ch_title: '操作',
            valueType: 'option',
            render: (text, record, _, action) => [
                <a
                    key="editable"
                    onClick={() => {
                        // console.log("text:", text, record, action);
                        // console.log("record:", record);//行数据的JSON obj
                        // console.log("action:", action);
                        action ?.startEditable ?.(record['序号']);
                    }}
                >
                    {langValue == 0 ? '编辑Edit' : (langValue == 1 ? '编辑' : 'Edit')}
                </a>
            ],
        };
        let newCol = [...col];
        newCol.push(operCol);

        // ***列render时验证列并按需高亮
        // console.log(newCol);
        newCol.push(prev_validColumn);
        newCol.forEach((item, i) => {
            if (i == newCol.length - 1) {
                item.render = (text, record, index) => {
                    //整行的验证状态
                    return !record.rcdValid ? (<font color='red'>{langValue == 0 ? <>异常<br />Not Active</> : (langValue == 1 ? '异常' : 'Not Active')}</font>) : (langValue == 0 ? <>正常<br />Active</> : (langValue == 1 ? '正常' : 'Active'));
                }
            }
            if (i == 5) {
                // @@TODO purpose
                // 渲染用途字段的验证提示
                // item.render = (text, record) => {
                //     let purposeStr = record['用途'];
                //     const arr = projectArr.filter(item => purposeStr == text)

                //     let valid = record.purposeValid;
                //     // 校验：必填
                //     return !valid ? (
                //         <Tooltip title={'不存在该项目！'} trigger="hover">
                //             <div style={{ color: 'red' }}>
                //                 {(purposeStr == 'undefined' || !purposeStr) ? '未填' : purposeStr}
                //             </div>
                //         </Tooltip>
                //     ) : (<>{arr[0] ?.ch_pro}</>);
                // }
                // 渲染用途组件
                item.renderFormItem = (_, record) => {
                    return (
                        <Select
                            placeholder={langValue == 0 ? '请选择(Please select)' : (langValue == 1 ? '请选择' : 'Please select')}
                            showSearch
                        >
                            {projectArr ?.map((item2, index) => {
                                return <Option key={index} value={item2 ?.ch_pro}>{item2 ?.ch_pro}</Option>
                            })}
                        </Select>
                    )
                }
            }
            if (i == 7) {
                // 渲染志工编号组件
                item.renderFormItem = (_, record) => {
                    return (
                        <Select
                            placeholder={langValue == 0 ? '请选择(Please select)' : (langValue == 1 ? '请选择' : 'Please select')}
                            showSearch
                            onChange={(value) => {
                                console.log('value:', value);
                                console.log('record:', record);
                                // 查找选中的编号对应的志工姓名
                                const selectedVolunteer = volunList.find(v => v.volunteer_code === value);
                                let fv = {
                                    [`${record.recordKey}`]: {
                                        '志工编号': value,
                                        '志工姓名': selectedVolunteer ? selectedVolunteer.volunteer_name : '',
                                        '志工英文名': selectedVolunteer ? selectedVolunteer.vol_en_name : '',
                                    },
                                };
                                console.log('fv:', fv)
                                // // 更新当前行的志工编号和志工姓名
                                record['志工英文名'] = selectedVolunteer ?.vol_en_name;
                                record['志工姓名'] = selectedVolunteer ?.volunteer_name;
                                rform.setFieldsValue(fv);
                            }
                            }
                        >
                            {volunList ?.map((item2, index) => {
                                return <Option key={index} value={item2 ?.volunteer_code}>{item2 ?.volunteer_code}</Option>
                            })}
                        </Select>
                    )
                }
            }
            //@tmpdel
            // if (item.dataIndex == '非陆籍填1') {
            //     // 渲染选择组件
            //     item.renderFormItem = (_, { isEditable }) => {
            //         return (
            //             <Select
            //                 placeholder={langValue == 0 ? '请选择(Please select)' : (langValue == 1 ? '请选择' : 'Please select')}
            //                 showSearch
            //                 options={[{ label: '1', value: '1' }, { label: ' ', value: '' }]}
            //             >
            //             </Select>
            //         )
            //     }
            // }
            // if (item.dataIndex == '法人填1，自然人不填') {
            //     // 渲染选择组件
            //     item.renderFormItem = (_, { isEditable }) => {
            //         return (
            //             <Select
            //                 placeholder={langValue == 0 ? '请选择(Please select)' : (langValue == 1 ? '请选择' : 'Please select')}
            //                 showSearch
            //                 options={[{ label: '1', value: '1' }, { label: ' ', value: '' }]}
            //             >
            //             </Select>
            //         )
            //     }
            // }
            // @tmptodo @@index
            if (i != 0 && i != 5 && i != 7 && i != 13 && i != 14) {
                item.renderFormItem = () => {
                    return <Input
                        type="text"
                        size="small"
                        style={{ height: '30px' }}
                        disabled={i == 8 || i == 9}
                        placeholder={langValue == 0 ? '请输入Please enter' : (langValue == 1 ? '请输入' : 'Please enter')}
                    />
                }
            }
            if (item.dataIndex == '邮箱') return
            if (item.dataIndex != '开立票据名称') {
                item.title = langValue == 0 ? <>{item.ch_title}<br />{item.en_title}</> : (langValue == 1 ? item.ch_title : item.en_title)
            }
        })
        return newCol;
    }

    const selectArea = (value) => {
        // console.log('selectArea:', value);
        SetChoosenArea(value);
    }


    const handleSave = () => {
        //先关闭搜索框再操作后续
        if (showSearchBar) {
            // console.log('取消筛选');
            Modal.error({
                title: langValue == 0 ? '请关闭筛选后继续操作！' : (langValue == 1 ? '请关闭筛选后继续操作！Please turn off filtering before continuing!' : 'Please turn off filtering before continuing!')
            });
            return;
        }

        upSertAxios('/billmgt/updateBillRecordSub', { billDetail: dataSource, area: choosenArea, recordId: props.recordId },
            (data) => {
                // console.log('审核保存成功 recordId:', props.recordId);

                // 关闭弹窗，并reset查询
                props.setModalVisible(false);
                props.reloadRecordList();
            },
            (e) => {
                console.log('billDetail upSert失败', e);
            },
            60000
        );
    }

    //暂存按钮
    const handleTempSave = () => {
        //先关闭搜索框再操作后续
        if (showSearchBar) {
            // console.log('取消筛选');
            Modal.error({
                title: langValue == 0 ? '请关闭筛选后继续操作！' : (langValue == 1 ? '请关闭筛选后继续操作！Please turn off filtering before continuing!' : 'Please turn off filtering before continuing!')
            });
            return;
        }

        upSertAxios('/billmgt/saveTempBillRecordSub', { billDetail: dataSource, area: choosenArea, recordId: props.recordId },
            (data) => {
                // console.log('审核暂存成功 recordId:', props.recordId);

                // 关闭弹窗，并reset查询
                props.setModalVisible(false);
                props.reloadRecordList();
            },
            (e) => {
                console.log('billDetail upSert失败', e);
            },
            60000
        );

    }


    const handleReCall = () => {
        //先关闭搜索框再操作后续
        if (showSearchBar) {
            // console.log('取消筛选');
            Modal.error({
                title: langValue == 0 ? '请关闭筛选后继续操作！' : (langValue == 1 ? '请关闭筛选后继续操作！Please turn off filtering before continuing!' : 'Please turn off filtering before continuing!')
            });
            return;
        }

        Modal.confirm({
            title: langValue == 0 ? '确定执行操作？Are you sure to perform the operation?' : (langValue == 1 ? '确定执行操作？' : 'Are you sure to perform the operation?'),
            content: langValue == 0 ? <>将退回给地方窗口重新编辑<br />Return to the local window for re editing</> : (langValue == 1 ? '将退回给地方窗口重新编辑' : 'Return to the local window for re editing'),
            onOk: () => {
                upSertAxios('/billmgt/updateBillRecordSub2Temp', { billDetail: dataSource, area: choosenArea, recordId: props.recordId },
                    (data) => {
                        //函数内部封装了提示
                        // console.log('审核退回成功 recordId:', props.recordId);
                        props.setModalVisible(false);
                        props.reloadRecordList();
                    },
                    (e) => {
                        // console.log('审核退回失败', e);
                    },
                    60000
                );
            },
            okText: langValue == 0 ? '确定Confirm' : (langValue == 1 ? '确定' : 'Confirm'),
        });

    }


    return (
        <div className="bill-mgt" id="bill-mgt">
            <div className='bill-mgt-nav'>
                <span className='content'>{langValue == 0 ? '待处理列表Pending list' : (langValue == 1 ? '待处理列表' : 'Pending list')}{'>'}{langValue == 0 ? '审核Review' : (langValue == 1 ? '审核' : 'Review')}</span>
                <Button className='back-button' type='link'
                    onClick={() => { props.setModalVisible(false) }}
                    icon={<UndoOutlined rotate="90" />}
                >
                    {/* <RollbackOutlined style={{ fontSize: '16px', fontWeight: '1900', color: '#08c' }} /> */}

                    {langValue == 0 ? '返回Return' : (langValue == 1 ? '返回' : 'Return')}
                </Button>
            </div>
            <div className="base-info">
                <h1 className="info-title">
                    {langValue == 0 ? '基础信息 Basic Information' : (langValue == 1 ? '基础信息' : 'Basic Information')}
                </h1>
                <div className='bi-content'>
                    <div className='bc-item'>
                        <span>{langValue == 0 ? '录入日期(Date of Entry )' : (langValue == 1 ? '录入日期' : 'Date of Entry ')}：</span>
                        <span>{props.recordDate}</span>
                    </div>
                    <div className='bc-item'>
                        <span>{langValue == 0 ? '地区(Region)' : (langValue == 1 ? '地区' : 'Region')}：</span>
                        <span>{props.recordArea}</span>
                    </div>
                    <div className='bc-item'>
                        <span>{langValue == 0 ? '志工人数Number of Volunteers' : (langValue == 1 ? '志工人数' : 'Number of Volunteers')}：</span>
                        <span>{props.recordVolCnt}</span>
                    </div>
                    <div className='bc-item'>
                        <span>{langValue == 0 ? '当前总金额(Current Balance)' : (langValue == 1 ? '当前总金额' : 'Current Balance')}：</span>
                        <span>{amount}</span>
                    </div>
                </div>
            </div>
            <div className="bill-info">
                <div className="info-title">
                    <span>{langValue == 0 ? '票据信息 Ticket Information' : (langValue == 1 ? '票据信息' : 'Ticket Information')}</span>
                </div>
                <div className='bill-table-container'>
                    <EditableProTable
                        sticky
                        rowKey="序号"//editableKeys
                        scroll={{
                            x: 960,
                        }}
                        recordCreatorProps={false}
                        loading={false}
                        columnEmptyText=''//空值时不显示'-',显示空字符串
                        columns={getColumns(columns)}
                        value={dataSource}
                        onChange={
                            (dataSrc) => {
                                // console.log('epTable onChange dataSrc:', dataSrc);
                                // 没有rawData时 重新编号,防止编辑更新时，重新排序
                                if (!rawData) {
                                    // console.log('没有rawData,重新生成序号');
                                    //重新生成序号
                                    dataSrc.forEach((d, i) => {
                                        d['序号'] = i + 1;
                                    })
                                }
                                setDataSource(dataSrc);
                            }
                        }
                        editable={{
                            type: 'single',//一次只编辑一行，else multiple
                            editableKeys: editableKeys,//使用（EditableProTable）rowKey 的配置
                            onlyOneLineEditorAlertMessage: '序号为' + editableKeys[0] + '的数据正在编辑，请先保存该行',
                            form: rform,
                            onSave: async (rowKey, data, row) => {
                                // console.log("onSave:", 'rowKey:', rowKey, 'data:', data, 'row:', row);
                                getRecordWithValid(data);
                                // await waitTime(100);
                                //若有筛选，保存当前dataSource的同时需要处理rawData
                                if (rawData) {
                                    for (let i = 0; i < rawData.length; i++) {
                                        if (rawData[i]['序号'] == rowKey) {
                                            rawData[i] = data
                                        }
                                    }
                                    // console.log(rawData);
                                }
                                let ds = dataSource;
                                ds[rowKey - 1] = data;
                                //重新生成序号
                                ds.forEach((d, i) => {
                                    d['序号'] = i + 1 + "";
                                })
                                // alert('ds:' + JSON.stringify(ds))
                                setDataSource(JSON.parse(JSON.stringify(ds)));
                            },
                            onDelete: async (rowKey, data, row) => {
                                // console.log("onDelete:", rowKey, data, row);
                                //若有筛选，需处理rawData
                                if (rawData) {
                                    //
                                    if (rawData != dataSource) {
                                        // console.log('raw != data on delete');
                                        let ds = rawData.filter((d) => rowKey != d['序号']);//删除当前行
                                        // console.log('onDelete filter:', ds);
                                        //重排序号
                                        ds.forEach((d, i) => {
                                            d['序号'] = i + 1
                                        });
                                        setRawData(ds);

                                    } else {
                                        // console.log('raw == data on delete');
                                        let ds = rawData.filter((d) => rowKey != d['序号']);//删除当前行
                                        // console.log('onDelete filter:', ds);
                                        //这个分支重新排序会报错
                                        setRawData(ds);
                                    }
                                }
                            },
                            onChange: (editableKeys, editableRows) => {
                                // console.log("onchange editableKeys:", editableKeys, typeof editableKeys[0]);
                                // console.log("editableRows:", editableRows);
                                setEditableRowKeys(editableKeys);
                            },
                            actionRender: (row, config, defaultDom) => {
                                // console.log("actionRender:", row);
                                return selectedRowKeysArr.includes(row['序号']) ? [defaultDom.save, defaultDom.cancel] : [defaultDom.save, defaultDom.delete, defaultDom.cancel];
                            },
                            saveText: <span id="bill-saveText">{langValue == 0 ? '保存Save' : (langValue == 1 ? '保存' : 'Save')}</span>,
                            deleteText: <span id="bill-delText">{langValue == 0 ? '删除Delete' : (langValue == 1 ? '删除' : 'Delete')}</span>,
                            cancelText: <span id="bill-canText">{langValue == 0 ? '取消Cancel' : (langValue == 1 ? '取消' : 'Cancel')}</span>,
                        }}
                        pagination={{
                            pageSize: 10,
                            pageSizeOptions: [10, 20, 50, 100, 1000],
                            showQuickJumper: true,
                            showSizeChanger: true,//可选每页条数，数据少时仍展示
                        }}
                        bordered
                    // rowClassName={(record, index) => record.notValid ? 'warning' : ''}
                    // rowSelection={rowSelection}
                    />
                    <Button
                        type="primary"
                        key="submit"
                        style={{ marginLeft: 40, marginBottom: 20 }}
                        onClick={() => {
                            // console.log('submit onClick，datasource*:', dataSource, "datasource str:", JSON.stringify(dataSource));
                            handleSave();
                        }}
                    >
                        {langValue == 0 ? '审核通过PASS' : (langValue == 1 ? '审核通过' : 'PASS')}
                    </Button>
                    <Button
                        type="ghost"
                        key="temp_save"
                        style={{ marginLeft: 40, marginBottom: 20 }}
                        onClick={() => {
                            handleTempSave();
                        }}
                    >
                        {langValue == 0 ? '暂存Save temporarily' : (langValue == 1 ? '暂存' : 'Save temporarily')}
                    </Button>
                    <Button
                        type="ghost"
                        key="temp"
                        style={{ marginLeft: 40, marginBottom: 20, backgroundColor: 'red', color: 'white' }}
                        onClick={() => {
                            // console.log('temp onClick，datasource*:', dataSource, "datasource str:", JSON.stringify(dataSource));
                            handleReCall();
                        }}
                    >
                        {langValue == 0 ? '退回No Pass' : (langValue == 1 ? '退回' : 'No Pass')}
                    </Button>
                    <Button className='back-button-bottom' type='link' style={{ position: 'absolute', right: '20px', fontWeight: '600', fontSize: '16px' }}
                        onClick={() => { props.setModalVisible(false) }}>
                        <RollbackOutlined style={{ fontSize: '16px', fontWeight: '1900', color: '#08c' }} />
                        {langValue == 0 ? '返回Return' : (langValue == 1 ? '返回' : 'Return')}
                    </Button>
                </div>
            </div>
        </div >
    )
}
